import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { IAddress } from './invoiceTypes'

const Styles = styled.ul`
  list-style-type: none;
  padding: 4px 0 0;
  margin: 0;
`

function InvoiceAddress({
  name,
  lineOne,
  lineTwo,
  town,
  county,
  postcode,
}: IAddress): ReactElement {
  return (
    <Styles>
      {name && <li>{name}</li>}
      {lineOne && <li>{lineOne}</li>}
      {lineTwo && <li>{lineTwo}</li>}
      {town && <li>{town}</li>}
      {county && <li>{county}</li>}
      {postcode && <li>{postcode}</li>}
    </Styles>
  )
}
export default InvoiceAddress
